import React from 'react';
  
// Creating the context object and passing the default values.
const FilterContext = React.createContext({status:null});
  
export default FilterContext;